<template>
    <div></div>
</template>

<script>
import {  
    PRODUCT_DETAIL_VIEW_EVENT_NAME, 
    BEGIN_CHECKOUT_EVENT_NAME,
    TRANSACTION_EVENT_NAME,
    REMOVE_FROM_CART_EVENT_NAME,
    PRODUCT_IMPRESSION_EVENT_NAME,
    VIEW_CART_EVENT_NAME,
    REVIEW_ORDER_EVENT_NAME
} from '../../constants/gtm-constants';
export default {
  props: [
    'eventName',
    'currentProduct',
    'basketProducts',
    'checkoutStepNumber',
    'checkoutStepOptions',
    'orderId',
    'productImpressions',
    'productImpressionFilter',
    'productImpressionStartIndex',
    'productImpressionImageType',
    'checkoutProducts',
    'selectedFilters',
    'inStock',
    'filterByFaceWeight'
  ],
  created(){
      switch (this.eventName) {
          case PRODUCT_DETAIL_VIEW_EVENT_NAME:
                this.$gtm.productDetailViewLoad(this.currentProduct);              
                break;
          case BEGIN_CHECKOUT_EVENT_NAME:
              this.$gtm.checkoutStep(this.basketProducts, this.checkoutStepNumber, this.checkoutStepOptions); 
              break;
          case TRANSACTION_EVENT_NAME:
              this.$gtm.transactionEvent(this.basketProducts); 
              break;
          case REMOVE_FROM_CART_EVENT_NAME:
              this.$gtm.removeFromCartEvent(this.currentProduct);
              break;
          case VIEW_CART_EVENT_NAME:
              this.$gtm.viewCartEvent(this.basketProducts, this.eventName);
              break;
          case REVIEW_ORDER_EVENT_NAME:
              this.$gtm.viewCartEvent(this.checkoutProducts, this.eventName);
              break;
          case PRODUCT_IMPRESSION_EVENT_NAME:
              this.$gtm.pushProductImpression(this.productImpressions, this.productImpressionStartIndex, this.productImpressionFilter, this.productImpressionImageType, this.selectedFilters, this.inStock, this.filterByFaceWeight);

      }

      document.addEventListener('remove-from-cart', this.removeFromCart)
  },
  methods:{
      removeFromCart: function(e){
          this.$gtm.removeFromCartEvent(e.detail);
      }
  }
}
</script>